import { ORDER_METHODS } from '../../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'bezorging',
    [ORDER_METHODS.PICKUP]: 'afhalen',
    [ORDER_METHODS.ON_SITE]: 'tafel',
  },
  feedback: {
    payment_method_disabled: 'We accepteren geen {{paymentMethod}}-betalingen voor {{orderMethod}}-bestellingen',
    cash_disabled: 'We accepteren geen contante betalingen voor {{orderMethod}}-bestellingen',
  },
};
